import { CRMMandate } from './Crm.types';
import { MarketData, MarketSegment } from './Market.types';

export type Mandate = CRMMandate & MarketData;

export type Mandates = {
  count: {
    countries: number;
    mandates: number;
    marketSegments: number;
    portfolios: number;
    territories?: number;
  };
  countries: Country[];
  marketSegments: MarketSegment[];
  portfolios: Portfolio[];
  territories?: Territory[];
};

// Still need to see where this type is actually used
// export type ExpansionOpportunity = {
//   author: string;
//   county: string;
//   date: Date;
//   labSupportResources: number;
//   portfolioFit: number;
//   principalId: string;
//   principalPortfolio: string;
//   rationale: string;
//   salesTeamStrength: number;
// };

export type ExpansionOpportunity = {
  ratings: RatingsValues;
  country: Country;
  marketSegment: MarketSegment;
  description: null | string;
  portfolio: null | Portfolio;
  portfolio2: null | Portfolio;
  createdOn: string;
};

export function isMandate(obj: Mandate | ExpansionOpportunity): obj is Mandate {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'aze_mandateid' in obj &&
    typeof (obj as Mandate).aze_mandateid === 'string'
  );
}

type RatingsValues = {
  labSupportResources?: string;
  portfolioFit?: string;
  salesTeamStrength?: string;
};

export type Country = {
  name: string;
  iso: string;
  id: string;
};

// check duplicate type
// export type Country = {
//   name: string;
//   value: string;
// };

export type Portfolio = {
  name: string;
  id: string;
};

export type Territory = {
  name: string;
};

export type PowerBIMandate = {
  email: string;
  manufacturerName: string | null;
  countryISO3: string;
  portfolio1name?: string;
  portfolio2name?: string;
  marketSegment: string | null;
};

export type SegmentName =
  | 'portfolio'
  | 'country'
  | 'marketSegment'
  | 'territory';

export type SelectedMandates = {
  [key in SegmentName]: string[];
};

export type MandateSelectionFilter = {
  [key: string]: {
    hasAllMandates?: boolean;
    portfolio: string[];
    country: string[];
    marketSegment: string[];
    territory: string[];
  };
};

export type MandateFiltersForPrincipal = {
  hasAllMandates?: boolean;
  country: string[];
  marketSegment: string[];
  portfolio: string[];
  territory: string[];
};
